import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

import DealerListComponent from './components/DealerListComponent.vue';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCxKbdh4GdLjIEQeWPfYl87tOOezFxP058',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
});
Vue.component('GmapCluster', GmapCluster);

const app = new Vue({ components: { DealerListComponent } });

app.$mount('#haendler-partner');
